import { ReactText } from 'react';
import { formatMonthDayYear, formatTimestamp } from 'common/util/time';
import { convertBytesToKilobyteStr } from 'common/util/transform';
import { TableHeader } from 'components/common/Table/Table';
import { AGENT_NAME_BY_TASK_TYPE, TASK_TYPES } from './DVEndpointDetailsRenderer.consts';

export function getApplicationHeaders(timezone: string | null): Array<TableHeader> {
  return [
    { content: 'Name', field: 'name', width: 160, className: 'Application__Col Application__Col__Name' },
    {
      content: 'Installed Date',
      field: 'installedDate',
      width: 88,
      className: 'Application__Col Application__Col__Date',
      renderCell: ({ value }: { value: ReactText }): ReactText =>
        formatMonthDayYear(Date.parse(value.toString()), timezone),
    },
    {
      content: 'Size',
      field: 'size',
      width: 88,
      className: 'Application__Col Application__Col__Size',
      renderCell: ({ value }: { value: number }): ReactText => convertBytesToKilobyteStr(value),
    },
    { content: 'Version', field: 'version', width: 100, className: 'Application__Col Application__Col__Version' },
    { content: 'Publisher', field: 'publisher', width: 140, className: 'Application__Col Application__Col__Publisher' },
  ];
}

export function getTasksHeaders(timezone: string | null): Array<TableHeader> {
  return [
    {
      content: 'Task Name',
      field: 'type',
      width: 140,
      className: 'Tasks__Col Tasks__Col__Name',
      renderCell: ({ value }: { value: TASK_TYPES }): ReactText =>
        AGENT_NAME_BY_TASK_TYPE[value]
          ? AGENT_NAME_BY_TASK_TYPE[value].taskName
          : AGENT_NAME_BY_TASK_TYPE.emptyValue.taskName,
    },
    {
      content: 'Description',
      field: 'description',
      width: 108,
      className: 'Tasks__Col Tasks__Col__Date',
    },
    {
      content: 'Status',
      field: 'status',
      width: 100,
      className: 'Tasks__Col Tasks__Col__Size',
    },
    { content: 'Initiated by', field: 'initiatedBy', width: 100, className: 'Tasks__Col Tasks__Col__Version' },
    {
      content: 'Initiated time',
      field: 'createdAt',
      width: 124,
      className: 'Tasks__Col Tasks__Col__Publisher',
      renderCell: ({ value }: { value: ReactText }): ReactText =>
        formatTimestamp(Date.parse(value.toString()), timezone),
    },
  ];
}

export function getTagsHeaders(timezone: string | null): Array<TableHeader> {
  return [
    {
      content: 'Key',
      field: 'key',
      width: 140,
      className: 'tags__Col Tags__Col__Key',
    },
    {
      content: 'Value',
      field: 'value',
      width: 108,
      className: 'Tags__Col Tags__Col__Value',
    },
    {
      content: 'Assigned At',
      field: 'assignedAt',
      width: 100,
      className: 'Tags__Col Tags__Col__Date',
      renderCell: ({ value }: { value: ReactText }): ReactText =>
        formatTimestamp(Date.parse(value.toString()), timezone),
    },
    {
      content: 'Applied By',
      field: 'assignedBy',
      width: 124,
      className: 'Tags__Col Tags__Col__AssignedBy',
    },
  ];
}
